import { request } from './api';
import config from '../config/index';
import * as constNames from '../services/const.service';
const appId = 'dealer.icsTast';
function headersToken() {
  return {
    headers: {
      Authorization: `signature ${sessionStorage.getItem(constNames.TOKEN_KEY)}`,
    },
  };
}
export default {
  /**
   * 根据带看通话标识获取订单列表
   * api地址： http://doc.phonebus.corpautohome.com/project/404/interface/api/34923
   * @param appId     appId
   * @param dealerId  店铺id
   * @param channelId 带看编号
   * @return 订单列表
   */
  getCallLeads({ dealerId, channelId, salesId }) {
    const url = '/vrtake/icsshare/getCallLeads';
    return request({
      type: 'get',
      url: config.vrar + url,
      ...headersToken(),
      data: { dealerId, channelId, salesId, _appId: appId },
    });
  },
  /**
   * 根据顾问加密串获取顾问信息
   * api地址： http://doc.phonebus.corpautohome.com/project/404/interface/api/34803
   * @param appId     appId
   * @param encryptedInfo  顾问id加密串
   * @return 顾问信息(包含token)
   */
  getSaleInfo({ encryptedInfo, dealerId }) {
    const url = '/vrtake/icsshare/getSaleInfo';
    return request({
      type: 'post',
      url: config.vrar + url,
      data: JSON.stringify({ encryptedInfo, dealerId, _appId: appId }),
      contentType: 'application/json',
    });
  },
  /**
   * 设置VR带看配置接口
   * api地址： http://doc.phonebus.corpautohome.com/project/900/interface/api/23372
   * @param appId     appId
   * @param saleId    顾问id
   * @param acceptVisit  VR带看-接受邀请配置:true-接受；false-不接受
   * @param messageOpen	  VR带看-短信消息通知配置：true-开通短信；false-关闭短信
   * @return returncode==0设置成功
   */
  setSalesVRVisitApi({ saleId, dealerId, acceptVisit, messageOpen }) {
    const url = `/api/sale/setting?_appId=${appId}`;
    return request({
      type: 'post',
      url: config.vrtake + url,
      data: JSON.stringify({ saleId, dealerId, acceptVisit, messageOpen }),
      contentType: 'application/json',
      transformResponse: function (data) {
        if (data && data.returncode === 0) {
          return { returncode: 0, message: '', result: data };
        } else {
          return {
            returncode: 1,
            message: 'setSalesVRVisitApi失败',
            result: data,
          };
        }
      },
    });
  },

  /**
   * 获取商家优惠统计
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/41677
   */
  getAractivityState(seriesId, dealerId) {
    const url = '/aractivity/discount/stats';
    return request({
      type: 'get',
      url: config.dealerCloudArVr + url,
      ...headersToken(),
      data: { seriesId, dealerId, _appId: appId },
    });
  },

  /**
   *  转化工具栏客户画像标签接口
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/41605
   */
  getPortrain(deviceId) {
    const url = '/vrtake/portrait/get';
    return request({
      type: 'get',
      url: config.dealerCloudArVr + url,
      ...headersToken(),
      data: { deviceId, _appId: appId },
    });
  },
  /**
   *  获取车辆配置信息
   *  http://doc.phonebus.corpautohome.com/project/302/interface/api/41551
   */
  getCarConfig(seriesId) {
    const url = '/vehicle/config/get';
    return request({
      type: 'get',
      url: config.dealerCloudArVr + url,
      ...headersToken(),
      data: { seriesId, _appId: appId },
    });
  },
  /**
   *  经销商的在售车系，可以根据参数X动态控制是否返回优惠信息
   *  http://doc.phonebus.corpautohome.com/project/302/interface/api/10172
   */
  getCarYHInfo(seriesId, dealerId) {
    const url = '/v2/dealerapi/series';
    return request({
      type: 'get',
      url: config.dealerCloudArVr + url,
      ...headersToken(),
      data: {
        _appId: appId,
        dealerId,
        seriesId,
        needPromotionCondition: 1,
      },
    });
  },
  /**
   *  根据dealerId和seriesIds查询商家有效红包活动
   *  http://doc.phonebus.corpautohome.com/project/302/interface/api/19051
   */
  getActivityPacketList(dealerId, seriesIds) {
    const url = '/aractivity/activityPacketListBy';
    return request({
      type: 'get',
      url: config.dealerCloudArVr + url,
      ...headersToken(),
      data: {
        _appId: appId,
        dealerId,
        seriesIds,
      },
    });
  },
  getActivityPacketAllList(dealerId) {
    const url = '/aractivity/activityPacketListBy';
    return request({
      type: 'get',
      url: config.dealerCloudArVr + url,
      ...headersToken(),
      data: {
        _appId: appId,
        dealerId,
      },
    });
  },
  /**
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/44539
   * 顾问备注添加
   * @param params
   * @returns
   */
  remark(params) {
    console.log('params: ', params);
    const {
      customerName, //客户名称
      phone, //手机号码
      channelId, //频道id
      saleId, //顾问id
    } = params;
    const url = `/api/channel/v1/sale/remark?_appId=${appId}`;
    return request({
      type: 'post',
      url: config.vrtake + url,
      data: JSON.stringify({ customerName, phone, channelId, saleId }),
      contentType: 'application/json',
      transformResponse: function (data) {
        if (data && data.returncode === 0) {
          return { returncode: 0, message: '', result: data };
        } else {
          return {
            returncode: 1,
            message: 'remarkApi失败',
            result: data,
          };
        }
      },
    });
  },
  /**
   * 挂断后通话报告
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/43903
   * 备注：下期再任务中心开打的时候，弹出，（如果是从vr带看结束之后过来）暂时没有使用
   */
  getCallReport(channelId) {
    // channelId = channelId ? channelId : '1041669607099838464';
    const url = '/api/channel/v1/call/report';
    return request({
      type: 'get',
      url: config.vrtake + url,
      ...headersToken(),
      data: {
        _appId: appId,
        channelId,
      },
    });
  },
  /**
   * 商擎分活动信息
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/52392
   * @param {*} encryptedInfo
   * @param {*} dealerId
   * @returns
   */
  getActivityBanners(encryptedInfo, dealerId) {
    const url = '/api/activity/info';
    return request({
      type: 'get',
      url: config.vrtake + url,
      data: {
        appId: appId,
        encryptedInfo,
        dealerId,
      },
    });
  },
};
